import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import { App } from './App';
import { socket } from './lib/socket';
import { ErrorBoundary } from './lib/ErrorBoundary';

// Mise à jour transparente de la PWA : quand une nouvelle version du service worker prend la main
// (après un déploiement), on recharge la page UNE fois automatiquement. Sans ça, l'ancienne page
// continuait de tourner avec un mélange ancien/nouveau code → écran d'erreur ponctuel corrigé « au refresh ».
if ('serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    // On ne recharge que sur une VRAIE mise à jour (un contrôleur existait déjà), pas à la 1re installation.
    if (hadController) window.location.reload();
  });
}

socket.connect();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
